var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#DCFCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9993 18.6667C24.6527 18.6667 18.666 24.6533 18.666 32C18.666 39.3467 24.6527 45.3333 31.9993 45.3333C39.346 45.3333 45.3327 39.3467 45.3327 32C45.3327 24.6533 39.346 18.6667 31.9993 18.6667ZM38.3727 28.9333L30.8127 36.4933C30.626 36.68 30.3727 36.7867 30.106 36.7867C29.8393 36.7867 29.586 36.68 29.3993 36.4933L25.626 32.72C25.2393 32.3333 25.2393 31.6933 25.626 31.3067C26.0127 30.92 26.6527 30.92 27.0393 31.3067L30.106 34.3733L36.9594 27.52C37.346 27.1333 37.986 27.1333 38.3727 27.52C38.7593 27.9067 38.7593 28.5333 38.3727 28.9333Z",
    fill: "#00A63E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesicon);
export default __webpack_public_path__ + "static/media/yesicon.16f66562a6398aea5dac4fea48cbee25.svg";
export { ForwardRef as ReactComponent };